<template>
  <a-config-provider :locale="zhCN">
    <a-drawer title="选择维修产品" width="900" :visible="visible" :destroy-on-close="false" @close="handleCancel">
      <!-- 搜索 -->
      <a-form layout="inline">
        <a-form-item label="分类" v-if="!categoryId">
          <a-select
            v-model="query.categoryId"
            allow-clear
            show-search
            placeholder="请选择"
            style="width: 160px"
            :filter-option="filterOption"
          >
            <a-select-option v-for="c in cateList" :key="c.id" :value="c.id">
              {{ c.categoryName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="名称">
          <a-input v-model="query.prodName" allow-clear placeholder="请输入" @keyup.enter="getList" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="getList">查询</a-button>
          <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
        </a-form-item>
      </a-form>

      <!-- 表格 -->
      <a-table
        row-key="id"
        :loading="loading"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :row-selection="{
          type: 'radio',
          selectedRowKeys: selectedKeys,
          onChange: onSelectChange,
        }"
      >
        <span slot="pic" slot-scope="text, record">
          <img :src="$url + record.imgs[0]" style="width: 40px; height: 40px; object-fit: cover" alt="" />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status == 1" color="green">上架</a-tag>
          <a-tag v-else color="red">下架</a-tag>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        size="small"
        style="margin-top: 16px; text-align: right"
        show-size-changer
        :current="query.pageNum"
        :page-size="query.pageSize"
        :total="total"
        @change="changePage"
        @showSizeChange="changeSize"
      />

      <!-- 底部按钮 -->
      <div class="drawer-footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" :disabled="!selectedKeys.length" @click="handleOk">确定</a-button>
      </div>
    </a-drawer>
  </a-config-provider>
</template>

<script>
import { categoryList } from '@/api/maintenance/classification'
import { fetchList } from '@/api/maintenance/product'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
export default {
  name: 'RepairProdPicker',
  props: {
    categoryId: [String, Number],
    value: [String, Number], // 回显 id
  },
  data() {
    return {
      zhCN,
      visible: false,
      loading: false,
      cateList: [],
      list: [],
      total: 0,
      selectedKeys: [],
      selectedRow: null,
      query: {
        pageNum: 1,
        pageSize: 10,
        status: 1, // 上架状态 0 下架 1上架
        categoryId: this.categoryId,
        prodName: '',
      },
      columns: [
        { title: '分类', dataIndex: 'categoryName', ellipsis: true },
        { title: '名称', dataIndex: 'prodName', ellipsis: true },
        { title: '图片', scopedSlots: { customRender: 'pic' }, align: 'center', width: 80 },
        { title: '状态', scopedSlots: { customRender: 'status' }, align: 'center', width: 90 },
      ],
      resolve: null,
    }
  },
  methods: {
    open() {
      this.visible = true
      this.selectedKeys = this.value ? [this.value] : []
      this.selectedRow = null
      this.loadCate()
      this.getList()
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    handleCancel() {
      this.visible = false
      this.resolve(null)
    },
    handleOk() {
      this.visible = false
      this.resolve(this.selectedRow)
    },
    loadCate() {
      categoryList().then((res) => (this.cateList = res.data.records))
    },
    getList() {
      this.loading = true
      fetchList(this.query).then((res) => {
        res.data.records.forEach((i) => (i.imgs = i.imgs ? JSON.parse(i.imgs) : []))
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
        if (this.value) this.selectedRow = this.list.find((item) => item.id === this.value) || null
      })
    },
    resetQuery() {
      this.query = { pageNum: 1, pageSize: 10, categoryId: this.categoryId, prodName: '' }
      this.getList()
    },
    changePage(p) {
      this.query.pageNum = p
      this.getList()
    },
    changeSize(cur, size) {
      this.query.pageSize = size
      this.getList()
    },
    onSelectChange(keys, rows) {
      this.selectedKeys = keys
      this.selectedRow = rows[0] || null
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>

<style scoped>
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #f0f0f0;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
}
</style>
